import { createSlideIcon, type IconProps } from '../SlideTypeIcon';

const DEFAULT_COLOR = 'var(--palette-green-500)';

const Icon24x24 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M8 19H8.71429C10.0337 19 11.2138 18.4346 12 17.5452C12.7862 18.4346 13.9663 19 15.2857 19H16V16.2903H15.2857C14.4967 16.2903 13.8571 15.6837 13.8571 14.9355V9.06452C13.8571 8.31626 14.4967 7.70968 15.2857 7.70968H16V5H15.2857C13.9663 5 12.7862 5.56545 12 6.45477C11.2138 5.56545 10.0337 5 8.71429 5H8V7.70968H8.71429C9.50327 7.70968 10.1429 8.31626 10.1429 9.06452V14.9355C10.1429 15.6837 9.50327 16.2903 8.71429 16.2903H8V19Z"
    fill={textColor}
  />
);

const Icon32x32 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <path
    fillRule="evenodd"
    d="M20.9188 6.72022H19.5716C18.1916 6.72022 16.9327 7.23904 15.9794 8.09227C15.0261 7.23904 13.7672 6.72021 12.3871 6.72021H11.04V10.3125H12.3871C13.3791 10.3125 14.1832 11.1166 14.1832 12.1086V19.8918C14.1832 20.8838 13.3791 21.688 12.3871 21.688H11.04V25.2802H12.3871C13.7672 25.2802 15.0261 24.7614 15.9794 23.9082C16.9327 24.7614 18.1916 25.2802 19.5716 25.2802H20.9188V21.688H19.5716C18.5797 21.688 17.7755 20.8838 17.7755 19.8918V12.1086C17.7755 11.1166 18.5797 10.3125 19.5716 10.3125H20.9188V6.72022Z"
    fill={textColor}
  />
);

export const QuizOpenIcon = createSlideIcon(Icon24x24, Icon32x32);
